import { Component, ViewChild, effect } from '@angular/core';
import { BenchmarkDashboardStorageService } from './benchmark-dashboard.storage.service';
import { LocalisationService } from '@localisation';
import { BenchmarkDashboardDataService } from './benchmark-dashboard.data.service';

import { EngeryBarChartComponent } from './charts/benchmark.barchart.component';
import { UserService } from '@user';
import { ExportAction, ImportAction } from '@tools';
import { TimeDateConverterService } from '@converter';
import { DatapointSelectorComponent } from './windows/datapoint-selector/datapoint-selector.component';
import { ClxFormComponent } from '@forms';
import { TenantService } from '@tenant';
import { ActionEvents, GlobalEventBus } from '@event-bus';
import { ClxDateTimeComponent } from '@forms/clx-forms/controls/clx.datetime.component';


@Component({
    selector: 'benchmark-dashboard',
    templateUrl: './benchmark-dashboard.template.html',
    standalone: false
})
export class BenchmarkDashboardComponent {
    constructor(
        public storage: BenchmarkDashboardStorageService,
        public localisationService: LocalisationService,
        public dataService: BenchmarkDashboardDataService,
        public userService: UserService,
        public dateConverter: TimeDateConverterService,
        public tenantService: TenantService,
        public eventBus: GlobalEventBus
    ){
        effect(() => {
            this.storage.data();
            if(this.isInit) {
                this.saveInLocalStorage();
                setTimeout(() => {
                    this.compareForm.validate();
                })
            }
        });

        this.eventBus.on(ActionEvents.loggedOut, () => {
            this.storage.reset();
        })
    }

    hasChanges: boolean = false;

    private saveInLocalStorage() {
        
        const key = this.userService.getUser().username + this.tenantService.getCurrentTenantId() + '-benchmark-dashboard-cash';
        localStorage.setItem(key, this.storage.exportDashboard())
    }

    private importFromLocalStorage() {
        const key = this.userService.getUser().username + this.tenantService.getCurrentTenantId() + '-benchmark-dashboard-cash';
        const cashed = localStorage.getItem(key);
        if(cashed) {
            this.storage.importDashboard(cashed)
            this.updateBar();
        }
    }

    @ViewChild('benchmarkChart')
    public benchmarkChart: EngeryBarChartComponent;

    @ViewChild('datapointWindow')
    public datapointWindow: DatapointSelectorComponent;

    @ViewChild('compareForm')
    public compareForm: ClxFormComponent;

    @ViewChild('from')
    public fromField: ClxDateTimeComponent;

    
    private getCurrentDate() {
        const currentDate = new Date();
        currentDate.setHours(23, 59, 59, 999);
        return currentDate.getTime();
    }

    public currentDate: number = this.getCurrentDate();

    private updateTimer : any;
    public updateBar(){
        const data = this.storage.data();
        
        this.hasChanges = false;
        //bundle change request
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => {
            if(this.compareForm.isValid) {
                this.benchmarkChart.update(data);
                this.hasChanges = false;
            }
         
        }, 30)
    }

    public export() {
        const exporter = new ExportAction({
            filetype : 'application/json',
            filename : 'BenchmarkDashboard-'
                + this.dateConverter.convertFormat(Date.now(), 'yyyy-MM-ddTHH-mm-ss')
                + '.json'
        })
        exporter.exportFile(this.storage.exportDashboard())
    }

    public async import() {
        const importer = new ImportAction({ accept : 'application/json'})
        const data = await importer.importFile();
        this.storage.importDashboard(data.data);
        this.updateBar();
    }

    public dateFormat: string = this.localisationService.getDateFormat();

    private isInit: boolean = false;

    public subscriptions = []

    public ngAfterViewInit() {
        //@Todo check why store will be overwriten at startup
        this.subscriptions.push(
            this.storage.onPropertyChanged.subscribe((data) => {
                if(data?.property === 'showSeriesLabel') {
                    return;
                }else if(
                    data?.property === 'chartWidth'
                    || data?.property === 'datapoint'
                ){
                    setTimeout(() => {
                        this.updateBar()
                    }, 100)
                }else{
                    this.hasChanges = true;
                }           
            })
        )
        setTimeout(() => {
            this.importFromLocalStorage();
            this.isInit = true;
        }, 1000)
    }  
    
    public handleTileDrop(e) {
        const data = JSON.parse(e.dataTransfer.getData('text'));
        const newDatapoint = {
            datapointId : data.tileConfig.datapointId,
            plantId :  data.tileConfig.plantId
        }
        this.datapointWindow.addDatapoint(newDatapoint);
        e.preventDefault();
    }

    public compareCheckboxChanged(data: any) {
        if(data === false) {
            this.storage.set('compareRange', null)
        }else if(data === true){
            this.storage.set('compareRange', 'day')
        }
    }


    public setToDate(date) {
        const dateObject = new Date(date);
        dateObject.setHours(23, 59, 59, 999)
        const timeStamp = dateObject.getTime();
        this.storage.set('to', timeStamp)
        this.storage.set('from', this.storage.data()?.from)
    }

}